import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { GovXLogo } from "@/components/GovXLogo";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && user.role === "admin") nav("/govx-admin");
  }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      nav("/govx-admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-govx-black grain px-5">
      <form
        onSubmit={submit}
        data-testid="admin-login-form"
        className="relative z-10 w-full max-w-sm border border-white/10 bg-govx-charcoal/40 p-8"
      >
        <div className="flex justify-center">
          <GovXLogo variant="light" />
        </div>
        <p className="mt-6 text-center font-mono text-[0.62rem] uppercase tracking-[0.2em] text-govx-grey">
          Content Management
        </p>
        <div className="mt-8 space-y-5">
          <input
            data-testid="admin-email"
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="w-full border-b border-white/20 bg-transparent py-2.5 text-govx-paper outline-none focus:border-govx-lime"
          />
          <input
            data-testid="admin-password"
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="w-full border-b border-white/20 bg-transparent py-2.5 text-govx-paper outline-none focus:border-govx-lime"
          />
        </div>
        <button
          type="submit"
          disabled={loading}
          data-testid="admin-login-submit"
          className="mt-8 w-full rounded-full bg-govx-green py-3 text-sm font-semibold text-white transition-colors hover:bg-govx-green-deep disabled:opacity-60"
        >
          {loading ? "Signing in…" : "Sign In"}
        </button>
      </form>
    </div>
  );
}
